import { DataSourceAdapterService } from './data-source-adapter.service';

export default angular
  .module('sfMobile.services.data-source-adapter', [])
  .factory('DataSourceAdapterService', DataSourceAdapterService).name;
